import React from "react";
import "./LetterAnimated.styles.css";
const LetterAnimated = () => {
  return (
    <h1 className="home-text">
      <span className="normal-letter">H</span>
      <span className="normal-letter">i</span>
      <span className="normal-letter">,</span>
      <br />
      <span className="normal-letter">I</span>
      <span className="normal-letter">’</span>
      <span className="normal-letter">m</span>
      <span className="normal-letter"> </span>
      <span className="home-J">{"J"}</span>
      <span className="normal-letter">o</span>
      <span className="normal-letter">r</span>
      <span className="normal-letter">g</span>
      <span className="normal-letter">e</span>
      <span className="normal-letter">,</span>
      <br />
      <span className="normal-letter">w</span>
      <span className="normal-letter">e</span>
      <span className="normal-letter">b</span>
      <span className="normal-letter"> </span>
      <span className="normal-letter">d</span>
      <span className="normal-letter">e</span>
      <span className="normal-letter">v</span>
      <span className="normal-letter">e</span>
      <span className="normal-letter">l</span>
      <span className="normal-letter">o</span>
      <span className="normal-letter">p</span>
      <span className="normal-letter">e</span>
      <span className="normal-letter">r</span>
      <span className="normal-letter">.</span>
    </h1>
  );
};

export default LetterAnimated;
